import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afaf65a8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaf65a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afaf65a8')) {
      api.createRecord('afaf65a8', component.options)
    } else {
      api.reload('afaf65a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=afaf65a8&scoped=true&", function () {
      api.rerender('afaf65a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/member-top-up-list/modules/table-list/index.vue"
export default component.exports